(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["heat-level-bar"] && !Shopify.designMode) return;
  try {
    
class HybridSlider {
  constructor(groupElement) {
    this.group = groupElement;
    this.slider = this.group.querySelector('.icon-blocks-container.mobile-layout--slider');
    this.pagination = this.group.querySelector('.slider-pagination');
    
    if (!this.slider || !this.pagination) return;

    this.slides = this.slider.querySelectorAll('.text-icon-block');
    this.init();
  }

  init() {
    if (this.slides.length <= 1) {
      this.pagination.style.display = 'none';
      return;
    }

    this.pagination.innerHTML = '';
    this.dots = [];

    this.slides.forEach((_, index) => {
      const dot = document.createElement('button');
      dot.classList.add('slider-pagination__dot');
      dot.setAttribute('aria-label', `Go to slide ${index + 1}`);
      dot.addEventListener('click', () => this.onDotClick(index));
      this.pagination.appendChild(dot);
      this.dots.push(dot);
    });
    
    this.debouncedUpdate = this.debounce(this.update.bind(this));
    this.slider.addEventListener('scroll', this.debouncedUpdate, { passive: true });
    
    // Check visibility to avoid running on hidden sections
    this.observer = new IntersectionObserver(this.handleIntersection.bind(this), { threshold: 0.1 });
    this.observer.observe(this.slider);
  }
  
  handleIntersection(entries) {
    if (entries[0].isIntersecting) {
      this.update();
    }
  }

  onDotClick(index) {
    const slideWidth = this.slides[0].offsetWidth;
    const gap = parseInt(window.getComputedStyle(this.slider).gap) || 0;
    this.slider.scrollTo({
      left: index * (slideWidth + gap),
      behavior: 'smooth'
    });
  }

  update() {
    if (window.innerWidth >= 750) return; // Only run on mobile
    const slideWidth = this.slides[0].offsetWidth;
    const gap = parseInt(window.getComputedStyle(this.slider).gap) || 0;
    const scrollLeft = this.slider.scrollLeft;
    
    // A small tolerance to handle rounding issues
    const currentIndex = Math.round(scrollLeft / (slideWidth + gap));
    
    this.dots.forEach((dot, index) => {
      dot.classList.toggle('slider-pagination__dot--active', index === currentIndex);
    });
  }
  
  debounce(func, wait = 100) {
    let timeout;
    return function executedFunction(...args) {
      const later = () => {
        clearTimeout(timeout);
        func(...args);
      };
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
    };
  }
}

const initSlidersOnLoad = (container = document) => {
  container.querySelectorAll('.slider-group-wrapper').forEach(group => new HybridSlider(group));
}

document.addEventListener('DOMContentLoaded', () => initSlidersOnLoad());

if (typeof Shopify !== 'undefined' && Shopify.designMode) {
  document.addEventListener('shopify:section:load', (event) => initSlidersOnLoad(event.target));
  document.addEventListener('shopify:block:select', (event) => {
    const slider = event.target.closest('.icon-blocks-container.mobile-layout--slider');
    if (slider) {
      event.target.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
